var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"download-file"},[_c('DownloadSnackbar',{attrs:{"value":_vm.descargando,"progreso-descarga":_vm.progresoDescarga,"total-descarga":_vm.totalDescarga}}),_c('a',{ref:"fileAnchor",attrs:{"hidden":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }